export const timeFrameConfig = {
    all: { label: 'All' },
    ytd: { label: 'YTD' },
    month: { label: 'Month' },
    custom: { label: 'Custom' },
};
export const pairMetricConfig = {
    openOrders: {
        label: 'Open',
        title: 'Open Orders per Pair',
        description: 'Orders held open on each day, counted per pair',
    },
    openedOrders: {
        label: 'Opened',
        title: 'Orders Opened per Pair',
        description: 'Orders newly opened on each day, counted per pair',
    },
};
/** Local-midnight day key, matching how a trader reads a calendar date. */
export const toDayKey = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
/**
 * Resolve a time frame into an inclusive day-key range. `custom` passes the
 * caller's own range straight through.
 */
export const resolveTimeFrame = (timeFrame, today, customRange) => {
    switch (timeFrame) {
        case 'all':
            return {};
        case 'ytd':
            return { start: toDayKey(new Date(today.getFullYear(), 0, 1)), end: toDayKey(today) };
        case 'month': {
            const start = new Date(today);
            start.setDate(start.getDate() - 29);
            return { start: toDayKey(start), end: toDayKey(today) };
        }
        case 'custom':
            return customRange;
    }
};
const DAY_MS = 24 * 60 * 60 * 1000;
/**
 * Expand the RPC's sparse (day, pair) rows into the dense, gap-free rows the
 * chart draws. The server sends only days a pair actually traded; the zero
 * days are filled here so the x-axis stays continuous and cheap to ship.
 */
export const expandPairAnalysis = (response, hiddenPairs) => {
    const hidden = new Set(hiddenPairs);
    const pairs = response.pairs.filter((p) => !hidden.has(p.symbol));
    if (pairs.length === 0)
        return { points: [], pairs: [] };
    const byDay = new Map();
    for (const row of response.points) {
        if (hidden.has(row.pair))
            continue;
        let day = byDay.get(row.date);
        if (!day) {
            day = new Map();
            byDay.set(row.date, day);
        }
        day.set(row.pair, row.count);
    }
    const dayKeys = Array.from(byDay.keys()).sort();
    if (dayKeys.length === 0 && !response.windowStart)
        return { points: [], pairs: [] };
    const firstDay = response.windowStart ?? dayKeys[0];
    const lastDay = response.windowEnd ?? dayKeys[dayKeys.length - 1];
    if (!firstDay || !lastDay || firstDay > lastDay)
        return { points: [], pairs: [] };
    const points = [];
    for (let cursor = new Date(`${firstDay}T00:00:00`); toDayKey(cursor) <= lastDay; cursor = new Date(cursor.getTime() + DAY_MS)) {
        const dayKey = toDayKey(cursor);
        const day = byDay.get(dayKey);
        const point = { date: dayKey, total: 0 };
        let total = 0;
        for (const { symbol } of pairs) {
            const value = day?.get(symbol) ?? 0;
            point[symbol] = value;
            total += value;
        }
        point.total = total;
        points.push(point);
    }
    return { points, pairs };
};
